import React from "react";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";
import DraftModule from "./draft/index";

const pageConfig = {
  pageName: "Draft And Declines",
  moduleList: [DraftModule]
};

const DraftAndDeclinesPage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default DraftAndDeclinesPage;
